import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormQuestionsComponent} from './form-questions.component';

const routes: Routes = [
  {
    path: '',
    component: FormQuestionsComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FormQuestionsRoutingModule { }
